import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-logos',
    templateUrl: './logos.component.html',
    styleUrls: ['./logos.component.scss'],
    standalone: false
})
export class LogosComponent {

    @Input({required: true})
    public logo!: Logos;

}

export type Logos =  'mm-logo-dark'
    | 'mm-logo'
    | 'tb-logo-dark'
    | 'tb-logo'
    | 'slack-logo';
